export default "__VITE_ASSET__DQlGGM7N__"